import { render } from "./GeometryImporter.vue?vue&type=template&id=f3bbdfbc"
import script from "./GeometryImporter.vue?vue&type=script&lang=js"
export * from "./GeometryImporter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__